//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentOl', {
//        templateUrl: 'views/components/views/consignmentOl/consignmentOl.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'consignmentOlService', function ($stateParams, stateService, consignmentOlService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let consignmentOlKeyno = $stateParams.consignmentol_keyno;

//            vm.model = {
//                orderNumberButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderhead', { order_internal_no: vm.model.menu.order_internal_no }) }
//                ],
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await consignmentOlService.getMenu({ consignmentol_keyno: consignmentOlKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
